var React = require('react');

function Bath (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m23.495,15.873l.483-3.873H2v-7.667c0-1.286,1.047-2.333,2.333-2.333.73,0,1.429.349,1.867.933l.259.345-.574,3.29,1.071,1.67,5.777-4.333-1.071-1.67-3.607-.161-.256-.342c-.814-1.085-2.11-1.732-3.467-1.732C1.943,0,0,1.943,0,4.333v7.667l.519,3.873c.256,2.048,1.264,3.841,2.726,5.117l-.744,3.01h2.061l.452-1.832c1.085.533,2.301.832,3.578.832h6.831c1.273,0,2.485-.296,3.567-.826l.451,1.826h2.061l-.742-3.001c1.467-1.276,2.48-3.073,2.737-5.126Zm-14.904,5.127c-3.088,0-5.705-2.311-6.088-5.375l-.203-1.625h19.413l-.202,1.625c-.384,3.064-3.001,5.375-6.089,5.375h-6.831Z"}));
}

Bath.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"#FFFFFF"};

module.exports = Bath;

Bath.default = Bath;
